import { api } from "../api";

/**
 * Turns any passkey/WebAuthn failure into a human-readable reason and reports
 * it to the backend (/api/client-log) so production failures become visible.
 * Returns the string to show in the toast.
 */
export function describePasskeyError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  const name = e?.name || (e?.response ? `HTTP ${e.response.status}` : "Error");
  const msg = e?.message || (typeof detail === "object" ? JSON.stringify(detail) : "") || String(e || "");
  return `${name}: ${msg}`.slice(0, 220);
}

export function reportPasskeyError(context, e) {
  try {
    const payload = {
      context,
      error: describePasskeyError(e),
      detail: {
        name: e?.name || "",
        message: e?.message || "",
        code: e?.code || "",
        status: e?.response?.status || 0,
        responseDetail: typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "",
        stack: (e?.stack || "").slice(0, 600),
        native: !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()),
      },
    };
    api.post("/client-log", payload).catch(() => {});
  } catch (err) { /* never block the UX over telemetry */ }
}
